import React from 'react'
import { useStore } from '../../../../../lib/context'
import { observer } from 'mobx-react-lite';
import {motion} from 'framer-motion'
import SearchIcon from '../../../Icons/SearchIcon';

const NavModuleSearchButtonCollapsed = observer(() => {
    const {uiStore: {openNavModule}, articleQueryStore: {updateIsSearching, activeDataQueryID}} = useStore();
    return (
        <motion.div 
            className='flex--center nav-search--collapsed'
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0 }}
            transition={{delay: .25}}
            onClick={() => {
                updateIsSearching(true)
                openNavModule()
            }}
        >
            <SearchIcon/>
            <span className={activeDataQueryID ? 'active label' : 'label'}>Filter</span>   

            <style jsx>{`
                :global(.nav-search--collapsed) {
                    height: 80px;
                    border-radius: 20px;
                    background: black;
                    padding: 2px 12px;
                    color: white;
                    width: 100px;
                    height: 40px;
                    padding-left: 30px;
                    cursor: pointer;
                    transition: background .3s ease-in-out, color .3s ease-in-out;
                }


                :global(.nav-search--collapsed:hover) {
                    background: rgba(255,255,255,.75);
                    color: #333;
                }

                .label {
                    position: relative;
                }

                .label::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    right: -8px;
                    display: block;
                    height: 5px;
                    width: 5px;
                    border-radius: 50%;
                    background: #54B219;
                    position: absolute;
                    opacity: 0;
                }


                .active.label::after {
                    opacity: 1;
                    animation: blink 2s ease infinite;
                }

                :global(.nav-search--collapsed svg) {
                    margin-right: 4px;
                    position: absolute;
                    transform: translateX(-32px) translateY(-1px);
                    height: 15px;
                }


                :global(.nav-search--collapsed:hover path) {
                    fill: #333;
                }



                :global(.nav-search--collapsed:hover circle) {
                    stroke: #333;
                }



                @keyframes blink {
                    0% {
                     opacity: .3;
                    }
                    50% {
                     opacity: 1;
                    }
                    100% {
                     opacity: .3;
                    }
                }

                @media (max-width: 769px), (pointer: coarse) {
                    :global(.nav-search--collapsed) {
                        height: 32px;
                    }
                    .label {
                        font-size: 14px;
                    }
                }


            `}</style>
        </motion.div>
    )
})

export default NavModuleSearchButtonCollapsed